import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdStylioSnrsIo } from './pages'

type TIdToPageMapStylioSnrsIo = Record<PageIdStylioSnrsIo, TPageMapValue>

export const ID_TO_PAGE_MAP_STYLIO_SNRS_IO: TIdToPageMapStylioSnrsIo = {
  [PageIdStylioSnrsIo.AGE_SNRS_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs_io/pages/questions/AgeQuestion').then(
        (m) => ({
          default: m.AgeQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/questions/AgeQuestion'),
  },
  [PageIdStylioSnrsIo.URGE_SNRS_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs_io/pages/urge/UrgePage').then((m) => ({
        default: m.UrgePage,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_snrs_io/pages/urge/UrgePage'),
  },
  [PageIdStylioSnrsIo.HAIR_COLOR_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/questions/HairColorQuestion'
      ).then((m) => ({
        default: m.HairColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/questions/HairColorQuestion'),
  },
  [PageIdStylioSnrsIo.EYES_COLOR_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/questions/EyesColorQuestion'
      ).then((m) => ({
        default: m.EyesColorQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/questions/EyesColorQuestion'),
  },
  [PageIdStylioSnrsIo.JEWELRY_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/questions/JewelryQuestion'
      ).then((m) => ({
        default: m.JewelryQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/questions/JewelryQuestion'),
  },
  [PageIdStylioSnrsIo.BODY_SHAPE_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/questions/BodyShapeQuestion'
      ).then((m) => ({
        default: m.BodyShapeQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/questions/BodyShapeQuestion'),
  },
  [PageIdStylioSnrsIo.STYLIO_TO_HELP_SNRS_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs_io/pages/questions/StylioToHelp').then(
        (m) => ({
          default: m.StylioToHelp,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/questions/StylioToHelp'),
  },
  [PageIdStylioSnrsIo.TALL_SNRS_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs_io/pages/questions/TallQuestion').then(
        (m) => ({
          default: m.TallQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/questions/TallQuestion'),
  },
  [PageIdStylioSnrsIo.WEIGHT_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/questions/WeightQuestion'
      ).then((m) => ({
        default: m.WeightQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/questions/WeightQuestion'),
  },
  [PageIdStylioSnrsIo.URGE_2_SNRS_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs_io/pages/urge/UrgePageVariant2').then(
        (m) => ({
          default: m.UrgePageVariant2,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/urge/UrgePageVariant2'),
  },
  [PageIdStylioSnrsIo.SHOPPING_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/questions/ShoppingQuestion'
      ).then((m) => ({
        default: m.ShoppingQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/questions/ShoppingQuestion'),
  },
  [PageIdStylioSnrsIo.STYLE_MOST_MATTERS_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/questions/StyleMostMattersQuestion'
      ).then((m) => ({
        default: m.StyleMostMattersQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/questions/StyleMostMattersQuestion'
      ),
  },
  [PageIdStylioSnrsIo.FAVORITE_COLORS_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/questions/FavoriteColorsQuestion'
      ).then((m) => ({
        default: m.FavoriteColorsQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/questions/FavoriteColorsQuestion'
      ),
  },
  [PageIdStylioSnrsIo.LIKE_OR_DISLIKE_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/likeOrDislike/LikeOrDislikeVariant1SnrsIo'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant1SnrsIo,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/likeOrDislike/LikeOrDislikeVariant1SnrsIo'
      ),
  },
  [PageIdStylioSnrsIo.LIKE_OR_DISLIKE_11_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/likeOrDislike/LikeOrDislikeVariant2SnrsIo'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant2SnrsIo,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/likeOrDislike/LikeOrDislikeVariant2SnrsIo'
      ),
  },
  [PageIdStylioSnrsIo.LIKE_OR_DISLIKE_12_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/likeOrDislike/LikeOrDislikeVariant3SnrsIo'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant3SnrsIo,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/likeOrDislike/LikeOrDislikeVariant3SnrsIo'
      ),
  },
  [PageIdStylioSnrsIo.LIKE_OR_DISLIKE_13_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/likeOrDislike/LikeOrDislikeVariant4SnrsIo'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant4SnrsIo,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/likeOrDislike/LikeOrDislikeVariant4SnrsIo'
      ),
  },
  [PageIdStylioSnrsIo.LIKE_OR_DISLIKE_14_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/likeOrDislike/LikeOrDislikeVariant5SnrsIo'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant5SnrsIo,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/likeOrDislike/LikeOrDislikeVariant5SnrsIo'
      ),
  },
  [PageIdStylioSnrsIo.LIKE_OR_DISLIKE_15_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/likeOrDislike/LikeOrDislikeVariant6SnrsIo'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant6SnrsIo,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/likeOrDislike/LikeOrDislikeVariant6SnrsIo'
      ),
  },
  [PageIdStylioSnrsIo.LIKE_OR_DISLIKE_16_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/likeOrDislike/LikeOrDislikeVariant7SnrsIo'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant7SnrsIo,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/likeOrDislike/LikeOrDislikeVariant7SnrsIo'
      ),
  },
  [PageIdStylioSnrsIo.LIKE_OR_DISLIKE_17_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/likeOrDislike/LikeOrDislikeVariant8SnrsIo'
      ).then((m) => ({
        default: m.LikeOrDislikeVariant8SnrsIo,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/likeOrDislike/LikeOrDislikeVariant8SnrsIo'
      ),
  },
  [PageIdStylioSnrsIo.STYLES_FEEL_LIKE_YOU_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/questions/StylesFeelLikeYou'
      ).then((m) => ({
        default: m.StylesFeelLikeYou,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/questions/StylesFeelLikeYou'),
  },
  [PageIdStylioSnrsIo.URGE_4_SNRS_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs_io/pages/urge/UrgePageVariant4').then(
        (m) => ({
          default: m.UrgePageVariant4,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/urge/UrgePageVariant4'),
  },
  [PageIdStylioSnrsIo.BRAND_SNRS_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs_io/pages/questions/BrandQuestion').then(
        (m) => ({
          default: m.BrandQuestion,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/questions/BrandQuestion'),
  },
  [PageIdStylioSnrsIo.FIND_NEW_CLOTHES_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/questions/FindNewClothesQuestion'
      ).then((m) => ({
        default: m.FindNewClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/questions/FindNewClothesQuestion'
      ),
  },
  [PageIdStylioSnrsIo.NOTHING_TO_WEAR_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/questions/NothingToWearQuestion'
      ).then((m) => ({
        default: m.NothingToWearQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/questions/NothingToWearQuestion'
      ),
  },
  [PageIdStylioSnrsIo.OLD_CLOTHES_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/questions/OldClothesQuestion'
      ).then((m) => ({
        default: m.OldClothesQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/questions/OldClothesQuestion'),
  },
  [PageIdStylioSnrsIo.COMBINE_CLOTHES_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/questions/CombineClothesQuestion'
      ).then((m) => ({
        default: m.CombineClothesQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/questions/CombineClothesQuestion'
      ),
  },
  [PageIdStylioSnrsIo.OUTFIT_LOOK_SNRS_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs_io/pages/questions/OutfitLook').then(
        (m) => ({
          default: m.OutfitLook,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/questions/OutfitLook'),
  },
  [PageIdStylioSnrsIo.OPTIMIZE_BUDGET_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/questions/OptimizeBudgetQuestion'
      ).then((m) => ({
        default: m.OptimizeBudgetQuestion,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/questions/OptimizeBudgetQuestion'
      ),
  },
  [PageIdStylioSnrsIo.EVERYDAY_LIFESTYLE_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/questions/EverydayLifestyle'
      ).then((m) => ({
        default: m.EverydayLifestyle,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/questions/EverydayLifestyle'),
  },
  [PageIdStylioSnrsIo.CLIMAT_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/questions/ClimatQuestion'
      ).then((m) => ({
        default: m.ClimatQuestion,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/questions/ClimatQuestion'),
  },
  [PageIdStylioSnrsIo.URGE_3_SNRS_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs_io/pages/urge/UrgePageVariant3').then(
        (m) => ({
          default: m.UrgePageVariant3,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/urge/UrgePageVariant3'),
  },
  [PageIdStylioSnrsIo.PREPARE_FLOW_SNRS_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs_io/pages/prepareFlow/PrepareFlow').then(
        (m) => ({
          default: m.PrepareFlow,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/prepareFlow/PrepareFlow'),
  },
  [PageIdStylioSnrsIo.EMAIL_SNRS_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs_io/pages/email/Email').then((m) => ({
        default: m.Email,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_snrs_io/pages/email/Email'),
  },
  [PageIdStylioSnrsIo.EMAIL_CONSENT_SNRS_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs_io/pages/email/EmailConsent').then(
        (m) => ({
          default: m.EmailConsent,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/email/EmailConsent'),
  },
  [PageIdStylioSnrsIo.SUBSCRIPTIONS_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/subscriptions/SubscriptionsVariant1'
      ).then((m) => ({
        default: m.SubscriptionsVariant1,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/subscriptions/SubscriptionsVariant1'
      ),
  },
  [PageIdStylioSnrsIo.CANCEL_OFFER_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/cancel-offer/CancelOffer'
      ).then((m) => ({
        default: m.CancelOffer,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/cancel-offer/CancelOffer'),
  },
  [PageIdStylioSnrsIo.AI_STYLIST_UPSELL_SNRS_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs_io/pages/sub-upsell/SubUpsell').then(
        (m) => ({
          default: m.SubUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/sub-upsell/SubUpsell'),
  },
  [PageIdStylioSnrsIo.SUB_UPSELL_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/pdf-sub-upsell/PdfSubUpsell'
      ).then((m) => ({
        default: m.PdfSubUpsell,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/pdf-sub-upsell/PdfSubUpsell'),
  },
  [PageIdStylioSnrsIo.UPSELL_SNRS_IO]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_snrs_io/pages/upsell/Upsell').then((m) => ({
        default: m.Upsell,
      })),
    ),
    preload: () => import('nove8/cohorts/stylio_snrs_io/pages/upsell/Upsell'),
  },
  [PageIdStylioSnrsIo.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
  [PageIdStylioSnrsIo.DOWNLOAD_SNRS_IO]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_snrs_io/pages/download-app/DownloadDefault'
      ).then((m) => ({
        default: m.DownloadDefault,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_snrs_io/pages/download-app/DownloadDefault'),
  },
}
